import styled from "styled-components";

const UserSliderStyle = styled.div`
    .slick-slider {
        .slick-list {
            margin: 0 -15px;
            .slick-track {
                display: flex;

                .slick-slide {
                    height: auto;
                    padding: 0 15px;

                    @media only screen and (max-width:1535px) {
                        padding: 0 10px;
                    }

                    &>div {
                        height: 100%;
                        &>div {
                            height: 100%;
                        }
                    }
                }
            }
        }
   
    }
`
export default UserSliderStyle;